import {ConfigService} from 'shared';
import {ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorsService} from 'shared';
import {TrailerOperationType} from 'shared';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TrailerOperationTypeService extends StoreService<TrailerOperationType> {


  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(TrailerOperationType);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<TrailerOperationType>> {
    return this.http.get<ModelsList<TrailerOperationType>>(this.config.apiVerUrl('/app/trailer-operation-types'), {params: queryParams});
  }

  protected insert(values: TrailerOperationType): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/trailer-operation-types'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/trailer-operation-types/${id}`));
  }

  protected update(id, values): Observable<TrailerOperationType> {
    return this.http.put<TrailerOperationType>(this.config.apiVerUrl(`/app/trailer-operation-types/${id}`), values);
  }

}
